"use client"

import Link from 'next/link'
import { useRouter } from 'next/navigation';
import useStore from '@/store/store';
import { markPaymentIntentForReplay } from '@/utils/sentryReplay';

function PricingModal() {

    const router = useRouter()
    const { pricingModalConfig } = useStore()

    const handleUpgradeNow = () => {
        markPaymentIntentForReplay('pricing_modal_upgrade_clicked', {
            modalTitle: pricingModalConfig.title
        });
        document.getElementById("modal_pricing").close()
        router.push('/pricing')
    }

    return (
        <dialog id="modal_pricing" className="modal modal-bottom sm:modal-middle" style={{ backgroundColor: "#ffffff10", backdropFilter: "blur(8px)" }} >
            <div className="modal-box bg-black rounded-xl border border-base-300 shadow-xl shadow-base-300">

                <form method="dialog">
                    <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
                </form>

                <div className="mb-8 text-center">
                    <div className='flex justify-center items-center mb-4'>
                        <div className="bg-primary/20 p-3 rounded-full">
                            <img src="/diamond.svg" alt="" className='w-6 h-6' />
                        </div>
                    </div>
                    <div className="font-bold text-2xl mb-2">{pricingModalConfig.title}</div>
                    <p className="text-base text-base-content/75">{pricingModalConfig.description}</p>
                </div>

                <div className='px-12'>
                    <button className='btn btn-primary w-full text-lg' onClick={handleUpgradeNow}>Upgrade Now</button>
                </div>
            </div>
        </dialog>
    )
}

export default PricingModal
